import React from 'react';
import WebinarBanner from '@components/WebinarBanner';

export default function WebinarCallout() {
  return <WebinarBanner />;
}
